import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LENS_TYPES } from 'src/app/helpers/lenses.helper';
import { CompanyLenses } from 'src/app/models/company-lenses.model';

@Component({
    selector: 'app-go-bf-prog-vision',
    templateUrl: './bf-prog-vision.component.html',
    styleUrls: ['./bf-prog-vision.component.scss'],
    standalone: false
})
export class BfProgVisionComponent implements OnInit {
  @Input() isAgainstRecommendation: boolean = false;
  @Input() bfProgLenses: CompanyLenses[] = [];
  @Output() lensTypeChangeEvent = new EventEmitter<LENS_TYPES>();
  @Output() addLensToCartEvent = new EventEmitter<CompanyLenses>();

  public showGuidedBfProg: boolean = false;
  public showConfirmLined: boolean = false;
  public showProgressiveOptions: boolean = false;
  public linedBifocalLens!: CompanyLenses;
  public orderedProgLenses: CompanyLenses[] = []  
  
  constructor() { }

  ngOnInit(): void {
    this.setBfProgLensDisplay();
  }

  showSingleVision() {
    this.lensTypeChangeEvent.emit(LENS_TYPES.singleVision)
  }

  showProgressives() {
    if (this.orderedProgLenses.length > 1) {
      this.showConfirmLined = false;
      this.showProgressiveOptions = true;
    } else {
       // they can immediately proceed to the selection here
      this.selectLens(this.orderedProgLenses[0]);      
    }
  }

  setBfProgLensDisplay() {
    if (this.bfProgLenses.length > 1) {
      const linedBf = this.bfProgLenses.find(l => l.visionType == LENS_TYPES.bifocal);
      if (linedBf) {
        this.linedBifocalLens = linedBf
      }
      const progLenses = this.bfProgLenses.filter(l => l.visionType == LENS_TYPES.progressive);
      this.orderedProgLenses = progLenses.sort((a,b) => (a.price < b.price ? -1 : 1));
    } else {
      this.selectLens(this.bfProgLenses[0]);
    }
  }
  
  selectLens(selectedLens: CompanyLenses) {
    this.addLensToCartEvent.emit(selectedLens);
  }

  onAcceptedWarning() {
    if (this.bfProgLenses.length == 1) {
      this.selectLens(this.bfProgLenses[0]);
    } else {
      this.showGuidedBfProg = true;
    }
  }

}
